// extracted by mini-css-extract-plugin
module.exports = {"stat-wrap":"StatisticItem_stat-wrap__IqIMb","stat-value-wrap":"StatisticItem_stat-value-wrap__cgB81","stat-value-percent":"StatisticItem_stat-value-percent__s6Hw2"};